var $ = require('jquery');
var imagesLoaded = require('imagesloaded');
imagesLoaded.makeJQueryPlugin( $ );

loadMasonry('.masonry')


function initMasonry(target) {
    $(target).masonry({
        itemSelector: '.card',
    });
}

function reloadMasonry(target) {
  $(target).masonry('reloadItems')
}

function loadMasonry(target, options = {
	itemSelector: '.card',
}) {
	$(target).imagesLoaded()
		.done( function( instance ) {
			initMasonry(target)
			//console.log('all images successfully loaded');
		})
		.fail( function() {
			initMasonry(target)
			//console.log('all images loaded, at least one is broken');
		})
}

module.exports =  {
	loadMasonry,
  reloadMasonry
}
